export const validationTripPlanning = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "trip_plan_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("Trip Plan Name"),
        });
      }else if(data.length > 256){
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("Trip Plan Name"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "list_order":
      if (data === null || data.length === 0) {
        error[namespace] = translate("Must Choose atleast 1 list order!");
      } else {
        error[namespace] = null;
      }
      break;
  
    default:
      break;
  }
  return error
}